<div class="from-to-display">
  <div class="from-to-display-container" [ngStyle]="{'background' :fromToDisplay?.toBackgroundColor}">
    <div class="from-to-display-option-from" *ngIf="fromToDisplay?.from > 0"
         [ngStyle]="{'color': fromToDisplay?.textColor, 'background' :fromToDisplay?.fromBackgroundColor}">{{fromToDisplay?.from}}</div>
    <div class="from-to-display-option-to"
         [ngStyle]="{'color': fromToDisplay?.textColor}">{{fromToDisplay?.to}}</div>
  </div>
</div>
